(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hx-scroll-nav"] && !Shopify.designMode) return;
  try {
    (function initHxScrollNav() {
    if (window.__hxScrollNavReady) return;
    window.__hxScrollNavReady = true;

    function visibleItems(rail) {
      return Array.prototype.filter.call(rail.children, function (el) {
        if (el.nodeType !== 1) return false;
        if (el.hasAttribute('data-hx-scroll-skip')) return false;
        if (el.hidden) return false;
        if (el.classList.contains('is-hidden')) return false;
        var style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
    }

    function modeOf(root) {
      return root.getAttribute('data-hx-scroll-mode') || 'both';
    }

    function wantsArrows(mode) {
      return mode === 'arrows' || mode === 'both';
    }

    function wantsDots(mode) {
      return mode === 'dots' || mode === 'both';
    }

    function rebuildDots(root, rail, dots) {
      if (!dots) return;
      var items = visibleItems(rail);
      var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      var scrollable = max > 4 && items.length > 1;

      dots.hidden = !scrollable || !wantsDots(modeOf(root));
      if (dots.hidden) {
        dots.innerHTML = '';
        return;
      }

      if (dots.childElementCount !== items.length) {
        dots.innerHTML = '';
        items.forEach(function (_item, index) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'hx-scroll__dot';
          btn.setAttribute('data-hx-scroll-dot', String(index));
          btn.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          btn.setAttribute('role', 'tab');
          dots.appendChild(btn);
        });
      }
    }

    function activeIndex(rail) {
      var items = visibleItems(rail);
      if (!items.length) return 0;
      var left = rail.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      items.forEach(function (item, index) {
        var dist = Math.abs(item.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = index;
        }
      });
      return best;
    }

    function update(root) {
      var rail = root.querySelector('[data-hx-scroll-rail]');
      if (!rail) return;

      var mode = modeOf(root);
      var prev = root.querySelector('[data-hx-scroll-prev]');
      var next = root.querySelector('[data-hx-scroll-next]');
      var dots = root.querySelector('[data-hx-scroll-dots]');
      var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      var scrollable = max > 4;
      var left = rail.scrollLeft;

      if (prev && next) {
        var showArrows = scrollable && wantsArrows(mode);
        prev.hidden = !showArrows;
        next.hidden = !showArrows;
        if (showArrows) {
          prev.disabled = left <= 2;
          next.disabled = left >= max - 2;
        }
      }

      rebuildDots(root, rail, dots);
      if (dots && !dots.hidden) {
        var index = activeIndex(rail);
        Array.prototype.forEach.call(dots.children, function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
    }

    function scrollByDir(rail, dir) {
      var amount = Math.max(rail.clientWidth * 0.75, 180);
      rail.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    function scrollToIndex(rail, index) {
      var items = visibleItems(rail);
      var item = items[index];
      if (!item) return;
      rail.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    }

    function bind(root) {
      if (root.dataset.hxScrollBound === 'true') return;
      root.dataset.hxScrollBound = 'true';

      var rail = root.querySelector('[data-hx-scroll-rail]');
      if (!rail) return;

      var prev = root.querySelector('[data-hx-scroll-prev]');
      var next = root.querySelector('[data-hx-scroll-next]');
      var dots = root.querySelector('[data-hx-scroll-dots]');

      if (prev) {
        prev.addEventListener('click', function () {
          scrollByDir(rail, -1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          scrollByDir(rail, 1);
        });
      }
      if (dots) {
        dots.addEventListener('click', function (event) {
          var target = event.target.closest('[data-hx-scroll-dot]');
          if (!target) return;
          scrollToIndex(rail, Number(target.getAttribute('data-hx-scroll-dot')));
        });
      }

      rail.addEventListener(
        'scroll',
        function () {
          update(root);
        },
        { passive: true }
      );

      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () {
          update(root);
        });
        ro.observe(rail);
      }

      if (typeof MutationObserver !== 'undefined') {
        var mo = new MutationObserver(function () {
          update(root);
        });
        mo.observe(rail, { childList: true, subtree: true, attributes: true });
      }

      if (typeof IntersectionObserver !== 'undefined') {
        var io = new IntersectionObserver(
          function () {
            update(root);
          },
          { threshold: 0.01 }
        );
        io.observe(rail);
      }

      window.addEventListener('resize', function () {
        update(root);
      });
      update(root);
      requestAnimationFrame(function () {
        update(root);
      });
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-hx-scroll]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scan(document);
      });
    } else {
      scan(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
